import { render, staticRenderFns } from "./landing-navojoa.vue?vue&type=template&id=922531b0&scoped=true&"
import script from "./landing-navojoa.vue?vue&type=script&lang=js&"
export * from "./landing-navojoa.vue?vue&type=script&lang=js&"
import style0 from "./landing-navojoa.vue?vue&type=style&index=0&id=922531b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922531b0",
  null
  
)

export default component.exports